import * as z from "zod";

/**
 * Merchant-facing RCS on/off. Gated by the Redo-side `rcsAgentId`: with no agent
 * provisioned there is nothing to send under, so enabling this does nothing.
 */
export const ShopperAgentRcsConfigSchema = z.object({
  enabled: z.boolean().optional(),
});

export type ShopperAgentRcsConfig = z.infer<typeof ShopperAgentRcsConfigSchema>;
